import {
  ArtifactResponse,
  NoteSourceArtifactInfo,
} from "@/components/note/editor/source-bar/types";
import { api } from "@/modules/api";
import { SourceKind } from "@/store/sources/types";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";

export const useNoteSourceArtifactInfo = ({
  sourceId,
  isOpen,
  sourceKind,
}: {
  sourceId: string;
  isOpen: boolean;
  sourceKind: SourceKind;
}): NoteSourceArtifactInfo | null => {
  /**
   * Note that we fetch this for all source kinds, including TEXT_MESSAGEs.
   * This data powers the chips + subtitles.
   */
  const isEnabled = useMemo(() => isOpen, [isOpen]);

  const queryFn = useCallback(async () => {
    const response = await api.get("/v2/sources/{source_id}/artifact", {
      params: {
        path: { source_id: sourceId },
      },
    });

    if (response.error) {
      throw "Failed";
    }

    return response?.data;
  }, [sourceId]);

  const { data: result, isLoading } = useQuery({
    queryKey: ["note-source-artifact-info", sourceId],
    queryFn,
    enabled: isEnabled,
  });

  const artifactData = result as ArtifactResponse | null;

  const artifactInfo = {
    kind: sourceKind,
    artifactId: artifactData?.id,
    data: artifactData?.value,
    isLoading,
  } as NoteSourceArtifactInfo;

  return artifactInfo;
};
